import { Component } from "../component"
import { iterable } from "../helpers/iterable"

export class MiniCart extends Component {
  constructor(props) {
    super(props)

    this.dynamicClasses = {
      open: "-open",
      modalOpen: "-modal-open",
    }
  }

  ui() {
    return {}
  }

  toggle() {
    const { open, modalOpen } = this.dynamicClasses

    this.$el.classList.toggle(open)
    document.body.classList.toggle(modalOpen)
  }

  attachEvents() {
    const { open } = this.dynamicClasses
    const links = document.querySelectorAll(".mini-cart-toggle")

    iterable(links).forEach((link) => {
      link.addEventListener("click", (e) => {
        this.toggle()
        e.preventDefault()
      })
    })

    window.addEventListener("keyup", (e) => {
      if (e.code === "Escape" && this.$el.classList.contains(open)) {
        this.toggle()
      }
    })
  }

  created() {
    this.attachEvents()
  }
}
